// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: contents;
}

.card-collapsable-arrow {
  cursor: pointer;
}

.collapse {
  overflow: hidden;
  transition: height 0.2s ease-out;
}

.card-deck :host {
  flex: 1 0 0%;
  margin-right: 0.75rem;
  margin-bottom: 0;
  margin-left: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/modules/app-common/components/card-collapsable/card-collapsable.component.scss"],"names":[],"mappings":"AAEA;EACI,iBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,gBAAA;EACA,gCAAA;AADJ;;AAIA;EAEY,YAAA;EACR,qBAAA;EACA,gBAAA;EACA,oBAAA;AADJ","sourcesContent":["@import 'styles/core/variables.scss';\n\n:host {\n    display: contents;\n}\n\n.card-collapsable-arrow {\n    cursor: pointer;\n}\n\n.collapse {\n    overflow: hidden;\n    transition: height 0.2s ease-out;\n}\n\n.card-deck :host {\n    -webkit-box-flex: 1;\n            flex: 1 0 0%;\n    margin-right: 0.75rem;\n    margin-bottom: 0;\n    margin-left: 0.75rem;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
